import { AppTableRowAnimateType, ITableData } from '../../components/AppTable/model';
import { commonActions } from '../actionTypes';
import { audiencesActions } from '../actionTypes/audiences';
import produce from 'immer';
import _set from 'lodash/set';
import { AudienceRuleGraphql } from '../../../generated/apollo-hooks';

export enum AudiencesTabs {
    Active = 'Active',
    Archived = 'Archived'
}

export const USER_IDENTIFIER_PROPERTY = 'username';

const defaultTableState = Object.freeze<ITableData>({
    sorting: {
        dataKey: 'updatedAt',
        direction: 'desc'
    },
    selectedIds: [],
    animateIds: new Map<string, AppTableRowAnimateType>(),
    filters: {}
});

export interface IAudiencesState {
    searchTerm: string;
    currentTab: AudiencesTabs;
    integrationsDataProperties: {
        [integrationId: string]: {
            [property: string]: AudienceRuleGraphql;
        };
    };
    tableState: { [key in AudiencesTabs]: ITableData };
}

export const audiencesInitialState: IAudiencesState = {
    searchTerm: '',
    currentTab: AudiencesTabs.Active,
    integrationsDataProperties: {},
    tableState: {
        [AudiencesTabs.Active]: { ...defaultTableState },
        [AudiencesTabs.Archived]: { ...defaultTableState }
    }
};

export default function audiencesReducer(state: IAudiencesState = audiencesInitialState, action: $TSFixMe): IAudiencesState {
    switch (action.type) {
        // case commonActions.ENVIRONMENT_CHANGED:
        case commonActions.SYSTEM_CHANGED: {
            return {
                ...state,
                ...audiencesInitialState
            };
        }

        case audiencesActions.SET_CURRENT_TAB: {
            return { ...state, currentTab: action.payload };
        }

        case audiencesActions.SET_SEARCH_TERM: {
            return { ...state, searchTerm: action.payload };
        }

        case audiencesActions.UPDATE_AUDIENCES_TABLE_STATE: {
            const { key, changes } = action.payload;

            return produce(state, draft => {
                Object.assign(draft.tableState[key], changes);
            });
        }

        case audiencesActions.RESET: {
            return {
                ...state,
                searchTerm: audiencesInitialState.searchTerm,
                tableState: { ...audiencesInitialState.tableState }
            };
        }

        case audiencesActions.SET_INTEGRATIONS_DATA_PROPERTY: {
            const { integrationId, property } = action.payload;

            return produce(state, draft => {
                _set(draft.integrationsDataProperties, [integrationId, property.property], property);
            });
        }

        default:
            return state;
    }
}
